export default __webpack_public_path__ + "static/media/grp1.f47dafbd.jpeg";